// ===== FLEXPAY CONFIG =====
const FLEXPAY_API = process.env.REACT_APP_FLEXPAY_API;
const FLEXPAY_MERCHANT = process.env.REACT_APP_FLEXPAY_MERCHANT;
const FLEXPAY_TOKEN = process.env.REACT_APP_FLEXPAY_TOKEN;
const CALLBACK_URL = process.env.REACT_APP_CALLBACK_URL;

export const PAYMENT_METHODS = [
    {
        id: 'mobile-money',
        label: 'Mobile Money',
        icon: 'solar:smartphone-bold-duotone',
        description: 'Airtel Money, M-Pesa, Orange Money',
        transactionType: 1,
    },
    {
        id: 'card',
        label: 'Carte bancaire',
        icon: 'solar:card-bold-duotone',
        description: 'Momentanément désactivé',
        transactionType: 2,
        disabled: true,
    },
];

const flexpayService = {
    async initiatePayment({ amount, currency, phone, reference, transactionType }) {
        const response = await fetch(`https://backend.flexpay.cd/api/rest/v1/paymentService`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: FLEXPAY_TOKEN,
            },
            body: JSON.stringify({
                merchant: FLEXPAY_MERCHANT,
                type: transactionType,
                phone,
                reference,
                amount: String(amount),
                currency,
                callbackUrl: CALLBACK_URL,
            }),
        });
        return response.json();
    },

    async checkTransaction(orderNumber) {
        const response = await fetch(`${FLEXPAY_API}/check/${orderNumber}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: FLEXPAY_TOKEN,
            },
        });
        return response.json();
    },
};

export default flexpayService;
